import { useState } from 'react';
import { LoginResponse2 } from '../../rest/LoginResponse2';

/** Hook para administrar el token de sesión que se utiliza
 * durante el proceso de login. Este token es distinto del
 * token de sesión utilizado en el resto de la aplicación.
 */
export const useLoginToken = () => {
  const [loginData, setLoginData] = useState<LoginResponse2 | undefined>();
  const token = loginData ? loginData.token : undefined;

  function saveSession(token?: string) {
    setLoginData({
      token: token,
    });
  }

  /** Validadación de token*/
  function checkToken(): boolean {
    return token != null && token.length > 0;
  }

  function resetLoginToken() {
    setLoginData(undefined);
  }

  return [token, saveSession, checkToken, resetLoginToken] as const;
};
